export default __webpack_public_path__ + "images/ANWB_logo.1fdc8059d16731b7068fd922f668670c.svg";